/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Amount_InvalidInputs */

const en_editor_amount_invalid = /** @type {(inputs: Editor_Amount_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unclear amount, e.g. 200, 1.5 or 2–3.`)
};

const de_editor_amount_invalid = /** @type {(inputs: Editor_Amount_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Menge ist unklar, z. B. 200, 1,5 oder 2–3.`)
};

/**
* | output |
* | --- |
* | "Unclear amount, e.g. 200, 1.5 or 2–3." |
*
* @param {Editor_Amount_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_amount_invalid = /** @type {((inputs?: Editor_Amount_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Amount_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_amount_invalid(inputs)
	return en_editor_amount_invalid(inputs)
});